import { useQuery } from "@tanstack/react-query";
import { api } from "@/lib/api";

const MONTH = (m) => new Date(`${m}-01T12:00:00`).toLocaleDateString("fr-FR", { month: "long", year: "numeric" });

const SITE = (r) => (r.accueil ?? 0) + (r.menu ?? 0) + (r.fiche ?? 0) + (r.guide ?? 0) + (r.conseil ?? 0);
const TOTAL = (r) => (r.confirmation ?? 0) + (r.expedition ?? 0) + (r.panier ?? 0) + SITE(r);

export function FormationClicks() {
  const { data } = useQuery({ queryKey: ["formation-clicks"], queryFn: () => api.get("/admin/formation-clicks").then((r) => r.data) });
  const rows = Array.isArray(data) ? data : [];
  return (
    <section data-testid="admin-formation-clicks" className="mt-12 rounded-sm border border-[var(--line)] p-6">
      <h3 className="font-display text-2xl">Formation · code CLIENTE10</h3>
      <p className="mt-2 text-sm text-[var(--parchment)]/80">Clics vers la formation (emails, panier, accueil, menu, fiches produits, guides et conseils), par mois. Le nombre de codes réellement utilisés se consulte sur le site ozentyaformation.com.</p>
      {rows.length === 0 ? <p data-testid="formation-clicks-empty" className="mt-5 text-sm text-[var(--parchment)]/80">Aucun clic pour l'instant.</p> : (
        <table className="mt-5 w-full text-sm">
          <thead><tr className="text-left text-xs uppercase tracking-[0.16em] text-[var(--parchment)]/70"><th className="py-2">Mois</th><th>Email confirmation</th><th>Email expédition</th><th>Panier</th><th>Site (accueil, menu, fiches, guides, conseils)</th><th>Total</th></tr></thead>
          <tbody>
            {rows.map((r) => (
              <tr key={r.month} data-testid={`formation-clicks-${r.month}`} className="border-t border-[var(--line)]">
                <td className="py-3 capitalize">{MONTH(r.month)}</td><td>{r.confirmation ?? 0}</td><td>{r.expedition ?? 0}</td><td>{r.panier ?? 0}</td><td>{SITE(r)}</td>
                <td className="font-semibold text-[var(--gold-soft)]">{TOTAL(r)}</td>
              </tr>
            ))}
          </tbody>
        </table>
      )}
    </section>
  );
}
